import {
    defineComponents,
    DocumentReaderService,
    ImageQualityChecks,

} from "@regulaforensics/vp-frontend-document-components";
import CommonClass from "@/utils/common.ts";
import {DocType} from "@/types_and_interfaces/types.ts";


function useDocReader() {
    const location = window.location.origin
    const regula_settings = CommonClass.general_settings.kyc.regula
    const endpoint = location + regula_settings.identity_card_doc_reader.endpoint
    const timeout_ms = regula_settings.identity_card_doc_reader.timeout_ms

    const inject_window = (inject: boolean, type:DocType) => {


        const decodedLicenseKey = atob(regula_settings.license_key);
        const trimmedLicenseKey = decodedLicenseKey.slice(1, -1);

        // https://docs.regulaforensics.com/develop/doc-reader-sdk/web-components/configuration/settings-attributes/
        // https://docs.regulaforensics.com/develop/doc-reader-sdk/web-components/configuration/parameters/
        if (typeof window !== "undefined" && location) {

            if (inject) {
                (window as any).RegulaDocumentSDK = new DocumentReaderService();
                defineComponents().then(() => (window as any).RegulaDocumentSDK.initialize({ license: trimmedLicenseKey }));
                
                (window as any).RegulaDocumentSDK.recognizerProcessParam = {
                    processParam: {
                        scenario: type === "old" ? regula_settings.scenario_old_identity_card : regula_settings.scenario,
                        mrzFormatsFilter: [
                            "2x36",
                            "3x30",
                        ],
                        // forceDocFormat: 5,
                        backendProcessing: {
                            // serviceURL: import.meta.env.VITE_CLIENT_KYC_IDENTITY_CARD_REGULA_DOC_READER_API
                            serviceURL: endpoint
                        },

                        imageQa: {
                            // expectedPass: ['dpiThreshold', 'glaresCheck', 'focusCheck'],
                            expectedPass: [
                                ImageQualityChecks.Glares,
                                ImageQualityChecks.Focus,
                                ImageQualityChecks.Resolution,
                                // ImageQualityChecks.Perspective,
                                // ImageQualityChecks.Bounds,
                                // ImageQualityChecks.Portrait,
                                // ImageQualityChecks.Brightness,
                            ],
                            dpiThreshold: 130,
                            glaresCheck: true,
                            glaresCheckParams: {
                                imgMarginPart: 0.05,
                                maxGlaringPart: 0.01,
                            },
                        },
                        multipageProcessing: true,
                        videoCaptureMotionControl: true,
                        videoRecord: { delay: 0, duration: timeout_ms ? timeout_ms : 60000 },
                        returnPackageForReprocess: true,
                        timeout: timeout_ms ? timeout_ms : 60000,

                    },
                };

            } else {
                (window as any).RegulaDocumentSDK = undefined

            }
        }
    }

    return {
        inject_window
    }

}

export default useDocReader